import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FooterArea } from './style'
import WelcomeModal from '../../WelcomeModal'
import AppDownloadButtons from '../../AppDownloadButtons'

const Component = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  
  return (
    <>
      <FooterArea>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', alignItems: 'center', paddingTop: '35px', paddingBottom: '25px' }}>
          <AppDownloadButtons variant="horizontal" />
          
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center', gap: '10px', marginTop: '0px', fontSize: '15px' }}>
            <span 
              onClick={() => setShowModal(true)}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              Terserah
            </span> - All rights reserved.
            <Link 
              to="/privacy" 
              style={{ marginLeft: '15px', marginRight: '15px', color: '#667eea', textDecoration: 'none' }}
            >
              {t('privacyPolicy')}
            </Link>
            |
            <Link 
              to="/terms" 
              style={{ marginLeft: '15px', marginRight: '15px', color: '#667eea', textDecoration: 'none' }}
            >
              {t('termsAndConditions')}
            </Link>
            <a
              href="https://instagram.com/terserah.id_indonesia"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: '10px', color: '#E4405F', fontSize: '1.5em', verticalAlign: 'middle' }}
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </FooterArea>
      <WelcomeModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default Component;